import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import AddDecreaseStock from "../AddDecreaseStock/AddDecreaseStock";
import CustomDialogBox from "../../../../../Components/CustomDialogBox/CustomDialogBox";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class DecreaseStockBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      notificationOpen: false,
      decreaseId: "",
    };
  }

  handleDialogOpen = (decreaseId) => {
    this.setState({
      dialogOpen: true,
      decreaseId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleEditDecrease = async (decreaseId, data) => {
    this.setState({
      editStatus: true,
      decreaseId,
    });
    await this.props.handleEditData(data);
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDeleteDecrement = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/item-categories/${this.props.categoryId}/decrement/${this.state.decreaseId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Item deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getCategoryDetails(this.props.categoryId);
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteDecrement();
      }
    }
  };

  render() {
    const { classes, index, data } = this.props;
    return this.state.editStatus ? (
      <AddDecreaseStock
        data={data}
        decreaseId={data._id}
        categoryId={this.props.categoryId}
        decreasedData={this.props.decreasedData}
        handleChange={this.props.handleChange}
        handleCancelEdit={this.handleCancelEdit}
        getCategoryDetails={this.props.getCategoryDetails}
        editStatus={true}
      />
    ) : (
      <TableRow>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.quantity}</TableCell>
        <TableCell align="center">{data.remarks}</TableCell>

        <TableCell align="center">
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleEditDecrease(data._id, data)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Delete"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteDecrement}
        />
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(DecreaseStockBody)));
